import AppShell from '@/components/layout/AppShell';
import { SignalEngineView } from "@/components/signals/SignalEngineView";

export default function SignalEnginePage() {
  return (
    <AppShell activeView="signals">
      <SignalEngineView />
    </AppShell>
  );
}
